import fixDateTimezone from '../../utils/fixDateTimezone';
import formatDate from '../../utils/formatDate';

// ÐÐ¾Ð»Ð¾Ð½ÐºÐ° Â«ÐÐ±Ð½Ð¾Ð²Ð»ÑÐ½Â» ÑÐ¿Ð¸ÑÐºÐ° Ð»Ð¸Ð´Ð¾Ð²: ÐºÐ¾Ð³Ð´Ð° Ð¿Ð¾ Ð»Ð¸Ð´Ñ Ð² Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¹ ÑÐ°Ð· Ð¿Ð¾Ð´Ð°Ð»Ð¸ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½Ðº. ÐÑÑÑÐ¾ â Ð°ÐºÑÐ¸Ð²Ð½Ð¾ÑÑÐ¸ Ð½Ðµ Ð±ÑÐ»Ð¾.
const leadUpdatedAt = (row) => (row?.lastActivityAt ? formatDate(fixDateTimezone(row.lastActivityAt), true) : '');

export default leadUpdatedAt;
